<template>
	<div class="body">
    <!-- 选择类型 -->
    <!-- <back :title="titlename"></back> -->
    <div class="perimg">
      <img :src="user.headimgurl" alt="">
      <p>{{user.nickname}}</p>
    </div>
    <div class="list">
      <router-link to="/Realinfo">
        <img src="../assets/images/myicon1.png" alt="">
        <span>实名认证</span>
      </router-link>
      <router-link to="/Appointmentlist">
        <img src="../assets/images/myicon3.png" alt="">
        <span>网格办业务</span>
      </router-link>
      <router-link to="/Doorlist">
        <img src="../assets/images/myicon2.png" alt="">
        <span>上门办业务</span>
      </router-link>
      
      
    </div>
    <!-- 底部 -->
    <tabbar></tabbar>
	</div>

</template>

<script>
export default {
    data() {
      return {
        titlename:"公司变更",
        openid:"",
        user:[]
      };
    },
    created:function(){
       this.openid = this.$store.state.openId
       console.log(this.openid)
       //this.openid = '123'
       this.getUser();
    },
    methods:{
      //跳转
      getUser(){
        this.$http.post(this.$store.state.host+"/interface/getUser",{openid:this.openid},{emulateJSON:true})
        .then(res=>{
          //发送成功
          if(res.body.code==0){
            this.user=res.body.userPd;
            console.log(this.user);
          }

          //if()
        },res=>{
           //发送失败
        })
      },

    }
  };
</script>

<style lang="less" scoped>
  body{
    background: #fbfbfb;
  }
  .body{
    background: url(../assets/images/bg.png) #fbfbfb top center no-repeat;
    font-size: .36rem;
    padding: 1.33rem .4rem .4rem;
    background-size: 100%;
    .perimg{
      background: white;
      border-radius: .05rem;
      text-align: center;
      padding-bottom: .36rem;
      img{
        width: 1.8rem;
        height: 1.8rem;
        border-radius: 50%;
        position: relative;
        top: -.5rem;
      }
      p{
        margin-top: -.36rem;
      }
    }
    .list{
      background: white;
      margin-top: .36rem;
      border-radius: .05rem;
      a{
        font-size: .3rem;
        font-weight: bold;
        display: block;
        color: #333;
        padding:.4rem;
        border-bottom:1px solid #f4f3f3;
        img{
          width: .58rem;
          height: .58rem;
          border-radius: .05rem;
        }
        span{
          position: relative;
          top: -.2rem;
          margin-left: .3rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/my.vue